import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { installErrorTracker } from './lib/error-tracker';

installErrorTracker({ app: 'admin' });

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
